import { MessageState } from './message.redux.types';

export const initialState: MessageState = {
  showMessage: false,
  code: '',
  type: '',
  message: '',
};
